import React, { forwardRef, useState } from 'react';
import { Input } from 'reactstrap';
import Toast from '../../Toast/Toast';

const EmailInput = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const [isValid, setIsValid] = useState(true);
  let className = '';

  const validateEmail = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    
    if (value.length === 0) {
      return;
    }

    if (value.length > 1 && emailRegex.test(value)) {
        setIsValid(true);
      } else {
        setIsValid(false);
        handleClearEmail();
      }
  }

  const handleEmailChange = (e) => {
    setValue(e.target.value);

    const target = {
        name: props.name,
        type: 'text',
        value: e.target.value,
        ...e
    };

    props.onChange({ target });
  };

  const handleClearEmail = () => {
    setValue('');
    const target = {
        name: props.name,
        type: 'text',
        value: ''
    };
    props.onChange({ target });
    Toast.error("E-mail inválido.");
  };

  if(!isValid){
    className="is-invalid";
  }

  return (
    <div ref={ref}>
      <Input
        id={'id_'+props.name} 
        onChange={handleEmailChange}
        className={className}
        value={value}
        type={props.type}
        name={props.name}
        readOnly={props.readOnly}
        autoFocus={props.autoFocus?true:false}
        maxLength={props.maxLength}
        onBlur={validateEmail}           
    />
    </div>
  );
})

export default EmailInput;